import { dehydrate } from '@tanstack/react-query'
import { getProps } from 'ssr/getProps'

import { getGeolocationKey } from '~map-search/queries/useGetGeolocation'

const toFloat = (value) => parseFloat(String(value))
const getLat = (req) => req?.headers['cloudfront-viewer-latitude']
const getLng = (req) => req?.headers['cloudfront-viewer-longitude']

export const fn = async (context, client) => {
  const { req, res } = context

  res?.setHeader(
    'Cache-Control',
    'public, s-maxage=10, stale-while-revalidate=59'
  )

  const lat = getLat(req)
  const lng = getLng(req)

  const cloudfrontUserGeolocation = {
    lat: toFloat(lat),
    lng: toFloat(lng)
  }

  await client.prefetchQuery({
    queryKey: getGeolocationKey(),
    queryFn: () => cloudfrontUserGeolocation
  })

  return {
    props: {
      dehydratedState: dehydrate(client)
    }
  }
}

export const getServerSideProps = getProps(fn)
